import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';
import RouteComponent from '../../components/RouteComponent';

export default class Page extends RouteComponent {
	render() {
		return (
			<DocumentTitle title="Odůvodnění">
				<TabbablePage
					module="reason"
					List={List}
					Form={Form}
					newTitle="Nové"
					listTitle="Seznam odůvodnění"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Reason/Page.js